export default __webpack_public_path__ + "static/media/all-group.e147e3d2.svg";